export default "__VITE_ASSET__CaCdyPYo__"